module.exports = __webpack_public_path__ + "img/5.3c74353b.png";